// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2T5vz","field":"styles_field__2I58u","fieldCol":"styles_fieldCol__3qKQN","diffCol":"styles_diffCol__2XJNZ","diff":"styles_diff__ejiS5"};